import React from "react";
import I1 from "../Assests/alratv_img/1.jpg";
import I2 from "../Assests/alratv_img/2.jpg";
import I3 from "../Assests/alratv_img/3.jpg";
import I4 from "../Assests/alratv_img/4.jpg";
import I5 from "../Assests/alratv_img/5.jpg";

const VisionCards = () => {
  return (
    <div className="bg-white py-8 md:py-[100px] flex flex-col gap-12 md:gap-[120px]">
      {[
        {
          img: I1,
          alt: "A Space for Belonging",
          title: "A Space for Belonging",
          text: "This new space isn’t just for filming — it’s for building a true spiritual home.",
          bullets: [
            "A welcoming place for international guests and spiritual contributors.",
            "A home-away-from-home for our global ALRA family.",
            "A place where all visitors feel a deep sense of belonging.",
          ],
        },
        {
          img: I2,
          alt: "A Strategic and Accessible Location",
          title: "A Strategic and Accessible Location",
          text: "This new space isn’t just for filming — it’s for building a true spiritual home.",
          bullets: [
            "Easy access via car, public transport, and international travel",
            "Invitation letters available for viewers worldwide to visit, stay, and experience ALRA TV in person",
          ],
        },
        {
          img: I3,
          alt: "A Multi-Religious Meditation Centre",
          title: "A Multi-Religious Meditation Centre",
          text: "Open to all faiths, no faith, and everyone in between",
          bullets: [
            "A sanctuary for stillness, reflection, peace, and unity",
            "A centre that truly belongs to everyone",
          ],
        },
        {
          img: I4,
          alt: "A Permanent Home for Our Celebrations",
          title: "A Permanent Home for Our Celebrations",
          text: "Gatherings that celebrate love, light, and the spiritual legacy connecting us all.",
          bullets: ["Jashan e Shahi", "Jashan e Younus", "Jashan e Riaz"],
        },
        {
          img: I5,
          alt: "Designed for Comfort and Community",
          title: "Designed for Comfort and Community",
          text: "",
          bullets: [
            "Ample parking space for all visitors",
            "Thoughtfully designed accommodations and facilities",
          ],
        },
      ].map((section, index) => (
        <div
          key={index}
          className="vision-card w-full max-w-[1440px] mx-auto flex flex-col xl:flex-row items-center justify-between px-4 md:px-[80px]"
        >
          <div
            className={`w-full xl:w-auto ${
              index % 2 !== 0 ? "xl:order-2" : ""
            } mb-6xl:mb-0`}
          >
            <img
              src={section.img || "/placeholder.svg"}
              alt={section.alt}
              className="w-full xl:w-[609px] h-auto xl:h-[367px] object-cover rounded-[12px] xl:rounded-[24px]"
            />
          </div>

          <div
            className={`text-[#222222] w-full xl:max-w-[600px] ${
              index % 2 !== 0 ? "xl:order-1" : ""
            }`}
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            <span className="inline-block w-[40px] xl:w-[60px] border-t-[4px] xl:border-t-[8px] border-[#DD0101] rounded mb-[4px] mt-4 xl:mt-9"></span>
            <h2 className="text-[28px] xl:text-[48px] font-bold mb-4 leading-tight xl:leading-[58px]">
              {section.title}
            </h2>
            <div className="text-[#666666] xl:text-[21px] leading-[30px] xl:leading-[32px]">
              <p className="mb-3 xl:mb-4">{section.text}</p>
              <ul className="list-disc pl-6 marker:text-[#DD0101] space-y-4 xl:space-y-4">
                {section.bullets.map((bullet, i) => (
                  <li key={i}>{bullet}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VisionCards;
